var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 12.7499C14.1668 12.3742 14.316 12.0139 14.5817 11.7482C14.8474 11.4825 15.2077 11.3333 15.5834 11.3333C15.9592 11.3333 16.3195 11.4825 16.5852 11.7482C16.8508 12.0139 17.0001 12.3742 17.0001 12.7499V19.0824L18.7143 19.2666L25.7126 22.3691C26.4634 22.7091 26.9168 23.4599 26.9168 24.2816V30.4583C26.8743 31.6199 25.9534 32.5408 24.7918 32.5833H15.5834C15.0451 32.5833 14.5351 32.3708 14.1668 31.9741L7.2251 26.0241L8.27343 24.9333C8.5426 24.6358 8.9251 24.4799 9.32176 24.4799H9.63343L14.1668 26.9166V12.7499ZM15.5834 7.08325C17.0863 7.08325 18.5277 7.68027 19.5904 8.74298C20.6531 9.80569 21.2501 11.247 21.2501 12.7499C21.2501 14.8749 20.1168 16.6741 18.4168 17.6516V15.9233C19.2809 15.1441 19.8334 14.0108 19.8334 12.7499C19.8334 11.6227 19.3857 10.5417 18.5886 9.74471C17.7916 8.94769 16.7106 8.49992 15.5834 8.49992C14.4563 8.49992 13.3753 8.94769 12.5782 9.74471C11.7812 10.5417 11.3334 11.6227 11.3334 12.7499C11.3334 14.0108 11.8859 15.1441 12.7501 15.9233V17.6516C11.0501 16.6741 9.91676 14.8749 9.91676 12.7499C9.91676 11.247 10.5138 9.80569 11.5765 8.74298C12.6392 7.68027 14.0805 7.08325 15.5834 7.08325Z",
    fill: "#B22539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover5);
export default __webpack_public_path__ + "static/media/discover5.6bbfda9d048218f4605133e9f35ade27.svg";
export { ForwardRef as ReactComponent };